import { useContext } from 'react';

import { NavContext } from '../contexts/nav.context';

export const useNav = () => {
  const context = useContext(NavContext);
  if (!context) {
    throw new Error('useNav must be used within a NavProvider');
  }
  return context;
};
